import React, {FC} from 'react'
import MainAsideMenuLayout from "@layouts/mainAsideMenuLayout/MainAsideMenuLayout";


const ReportsPage: FC<any> = (props) => {

  let {} = props

  return (
    <MainAsideMenuLayout>
      {/*<BackLinkLayout>*/}
      <div>Reports
      </div>
      {/*</BackLinkLayout>*/}
    </MainAsideMenuLayout>
  )
}

export default ReportsPage;